import { StaffAvailability, StaffAvailabilityDto } from 'types/staff'
import { toHHMM24 } from './string-localization-helper'

export function normalizeStaffAvailability(
    item: StaffAvailabilityDto
): StaffAvailability {
    const { fromTime, toTime } = item
    const from_date = new Date()
    const [from_hours, from_minutes] = fromTime ? toHHMM24(fromTime).split(':') : []
    from_date.setHours(parseInt(from_hours))
    from_date.setMinutes(parseInt(from_minutes))

    const to_date = new Date()
    const [to_hours, to_minutes] = toTime ? toHHMM24(toTime).split(':') : []
    to_date.setHours(parseInt(to_hours))
    to_date.setMinutes(parseInt(to_minutes))

    let expiryDate = new Date(item.effectiveDate as string)
    expiryDate.setDate(expiryDate.getDate() + 1)

    const services = item.services?.map((item) => ({
        id: item?.serviceId,
        name: item?.serviceName,
    }))

    return {
        id: item.id,
        availability: item.block ? 'Block' : 'Available',
        location: item.location?.id,
        location_space: item.locationSpaceIds,
        services: services as any[],
        serviceIds: item.services?.map((item) => item.serviceId) as string[],
        day_of_weeks: item.dayOfWeeks || [],
        start_date: item.effectiveDate,
        end_date: item.expiryDate || new Date(expiryDate).toLocaleDateString('en-US', {
            month: 'long',
            day: '2-digit',
            year: 'numeric',
        }),
        from_time: from_date,
        to_time: to_date,
        created_at: item.createdAt,
        all_day: item.allDay
    }
}
